const category = {
    EVENT: "1",
    KONSER: "2",
    OLAHRAGA: "3",
    WORKSHOP: "4",
    HEALING: "5",
    RETAIL: "6",
    KOMEDI: "7",
    ATRAKSI: "8",
    TAMAN_HIBURAN: "9",
    WATER_PARKS: "10",
    KEBUN_BINATANG: "11",
    TEMPAT_BERSEJARAH: "12",
    RACE: "19"
}

const groupCategory = {
    EVENT: [category.EVENT, category.KOMEDI, category.OLAHRAGA, category.KONSER, category.RACE],
    NON_EVENT: [category.HEALING, category.ATRAKSI, category.TAMAN_HIBURAN, category.KEBUN_BINATANG, category.TEMPAT_BERSEJARAH, category.WATER_PARKS]
}

export {
    category,
    groupCategory
}